import { render } from "./Discount.vue?vue&type=template&id=5257c0e7&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"

import "./Discount.vue?vue&type=style&index=0&id=5257c0e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5257c0e7"]])

export default __exports__